import React from 'react';
import { styled } from '@glitz/react';
import { translate } from '@polarnopyret/scope';
import { Main, Basic } from 'Shared/PageLayout';
import Viewport from 'Shared/Viewport';
import { ErrorMessage } from 'Shared/FeedbackMessage';

export { Appearance } from 'Shared/PageLayout';

const NoScript = styled(ErrorMessage, {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  top: '0',
  width: '100%',
});

type SharedPropType = {
  itemScope?: boolean;
  itemType?: string;
  noLink?: boolean;
  actionPath?: string;
  actionTitle?: string;
};

type StrictPropType = {
  //layout?: PageLayout;
};

export const BaseStrictPage: React.StatelessComponent<SharedPropType & StrictPropType> = ({
  noLink,
  ...restProps
}) => {
  // A page component must be a direct child to `CurrentPage`
  return (
    <Main>
      <NoScript component="noscript">{translate('/site/errors/JavaScriptRequired')}</NoScript>
      <Basic {...restProps} />
    </Main>
  );
};

type PropType = SharedPropType & {
  
};

const PageMainExtensive: React.StatelessComponent<PropType> = ({
  children,
  actionTitle,
  actionPath,
  ...passProps
}) => {
  return (
    <BaseStrictPage {...passProps}>{children}</BaseStrictPage>
  );
};

const PageMainCompact: React.StatelessComponent<PropType> = ({
  noLink,
  children,
  actionTitle,
  actionPath,
  ...passProps
}) => {
  return (
    <BaseStrictPage {...passProps}>{children}</BaseStrictPage>
  );
};

const Page: React.StatelessComponent<PropType> = props => (
  <Viewport>
    {(isCompact: boolean) => (isCompact ? <PageMainCompact {...props} /> : <PageMainExtensive {...props} />)}
  </Viewport>
);

export default Page;
